<template>
  <div class="clearfix bigbox">
    <div class="box clearfix fl">
      <div class="fl" style="padding-right: 10px">
        <img v-if="avatar == ' '" src="../../assets/user.png" alt="" />
        <img v-else :src="avatar" alt="" />
      </div>
      <div class="fr clearfix" style="width: 238px; overflow: hidden">
        <p style="font-size: 18px; padding-bottom: 10px">
          {{ logindata.user_nicename
          }}<el-tag
            type="danger"
            size="small"
            effect="dark"
            style="margin-left: 10px; margin-right: 50px"
          >
            {{ logindata.level }}
          </el-tag>
          <!-- <el-badge :value="2" class="item"> -->
          <el-tag
            effect="dark"
            size="small"
            @click="$router.push('/person/news')"
            class="news"
          >
            消息
          </el-tag>
          <!-- </el-badge> -->
        </p>
        <p style="margin-bottom: 10px">
          学校：
          <span v-if="schooldata"> {{ schooldata }}</span>
          <span v-else> 暂无</span>
          <!-- 济南经五路小学 -->
        </p>
        <p>
          负责班级：
          <span v-if="!classdata.length"> 暂无 </span>
          <span v-for="(item, index) in classdata" :key="index" v-else>
            {{ item.grade_name + item.class_name }}</span
          >
        </p>
      </div>
    </div>
    <div class="subject clearfix fr">
      <div class="fl" style="padding-top: 10px">
        <div class="fl" style="margin-right: 18px">
          <img src="../../assets/subject.png" alt="" />
        </div>
        <div class="fr">
          <p>
            {{ keben }}
            <el-tag
              class="changeSubject"
              effect="dark"
              type="danger"
              size="small"
              style="margin-left: 6px"
              @click="dialogFormVisible = true"
            >
              切换课本
            </el-tag>
          </p>
          <p style="margin-top: 10px">
            <!-- gfhfhfhf -->
            {{ pointCourse }}
          </p>
        </div>
      </div>
      <div class="fr four" style="margin-right: 30px; cursor: pointer">
        <el-row style="margin-bottom: 15px">
          <img src="../../assets/zujuan.png" alt="" /><span @click="hh"
            >智能组卷</span
          >
          <img src="../../assets/beike.png" alt="" /><span
            @click="$router.push('/prepareLessons')"
            >在线备课</span
          >
        </el-row>
        <el-row>
          <img src="../../assets/renwu.png" alt="" />
          <span @click="$router.push('/resourceCenter')">资源中心</span>
          <img src="../../assets/ziyuan.png" alt="" /><span
            @click="$router.push('/homework')"
            >布置任务</span
          >
        </el-row>
      </div>
    </div>
    <!-- 切换课本 弹出框 -->
    <el-dialog title="切换课本" :visible.sync="dialogFormVisible">
      <chapterid
        @chapterid="chapterid"
        @zjgid="zjgid"
        @zjsidCopy="zjsidCopy"
        @chapter_name="chapter_name"
      ></chapterid>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleSure(1)">取 消</el-button>
        <el-button type="primary" @click="handleSure(2)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import chapterid from "@/components/home/chapterid";
import URL from "@/api/index.js";
import eventBus from "../../api/eventBus";
export default {
  data() {
    return {
      dialogFormVisible: false,
      // form: {
      //   name: "",
      //   region: "",
      //   date1: "",
      //   date2: "",
      //   delivery: false,
      //   type: [],
      //   resource: "",
      //   desc: "",
      // },
      keben: "一年级语文上册 人教课标版",
      pointCourse: "第一组 汉语拼音",
      paperdataCopy: {
        token: JSON.parse(localStorage.getItem("loginInfo")).token,
        question_type: "",
        question_level: "",
        point_id: "",
        chapter_id: "",
      },
      chapteriddata: {
        gid: "",
        sid: 1,
      },
      formLabelWidth: "120px",
      logindata: {},
      schooldata: "",
      classdata: [],
      avatar: "",
    };
  },
  components: { chapterid },
  created() {},
  beforeMount() {
    this.logindata = JSON.parse(localStorage.getItem("loginInfo"));
    this.schooldata = localStorage.getItem("school");
    // console.log(this.logindata.avatar);
    if (JSON.parse(localStorage.getItem("kebenxx"))) {
      this.keben = JSON.parse(localStorage.getItem("kebenxx"));
    }
    if (localStorage.getItem("chapter_name")) {
      this.pointCourse = localStorage.getItem("chapter_name");
    }
    this.avatar = JSON.parse(localStorage.getItem("loginInfo")).avatar;
    if (JSON.parse(localStorage.getItem("info"))) {
      this.avatar = JSON.parse(localStorage.getItem("info")).avatar;
    }
    this.getMasterclass();
    this.getMasterschool();
    // this.user_details()
    eventBus.$on("avatar", (res) => {
      this.avatar = res;
    });
  },

  methods: {
    // 获取个人信息
    // user_details(){
    //   var that = this
    //   var data = {
    //     token:JSON.parse(localStorage.getItem('loginInfo')).token
    //   }
    //   this.$post(URL.user_details,data).then(function(res){
    //     console.log(res.result)
    //     that.personaldata = res.result
    //   })
    // },
    // 获取学校信息
    getMasterschool() {
      var data = {
        token: JSON.parse(localStorage.getItem("loginInfo")).token,
        school_id: JSON.parse(localStorage.getItem("loginInfo")).school_id,
      };
      this.$post(URL.get_school_info, data).then((res) => {
        // console.log(res);
      });
    },
    // 获取管理班级列表
    getMasterclass() {
      var data = { token: JSON.parse(localStorage.getItem("loginInfo")).token };
      this.$post(URL.getMasterclass, data).then((res) => {
        if (res.result) {
          // console.log(res.result[0]);
          this.classdata = res.result;
          eventBus.$emit("classdata", this.classdata);
          localStorage.setItem("classdata", JSON.stringify(this.classdata));
        }
      });
    },
    handleSure(res) {
      if (res == 2) {
      //   if (localStorage.getItem("chapterid").length == 8) {
      //   this.$message({
      //     message: "请选择具体的章节",
      //   });
      //   return false;
      // }
      this.dialogFormVisible = false;
        if (JSON.parse(localStorage.getItem("kebenxx"))) {
          this.keben = JSON.parse(localStorage.getItem("kebenxx"));
        }
      }else{
        this.dialogFormVisible = false;
      }
    },
    chapter_name(e) {
      this.pointCourse = e;
    },
    hh() {
      this.$router.push("/testPaper");
    },
    zjgid(val) {
      this.present = val;
      this.chapteriddata.gid = val;
      this.getQuestionType(this.chapteriddata);
    },

    chapterid(val) {
      // console.log(11111111111)
      this.paperdataCopy.chapter_id = val;
      this.paperlistconhttp(this.paperdataCopy);
    },
    zjsidCopy(val) {
      this.present = val;
      this.chapteriddata.sid = val;
      this.getQuestionType(this.chapteriddata);
    },
    getQuestionType(e) {
      //获取知识点题库题型
      var data = {
        sid: e.sid,
        scid: e.scid,
      };
      this.$post(URL.getQuestionType, data).then((res) => {
        this.gettypelist = [];
        this.gettypelist = this.gettypelist
        .concat(
          { type_id: 0, type_name: "全部" },
        )
        .concat(res.result);
      });
    },
    paperlistconhttp(e) {
      var data = {
        token: e.token,
        question_type: e.question_type,
        question_level: e.question_level,
        point_id: e.point_id,
        chapter_id: e.chapter_id,
      };
      this.$post(URL.GetQuestionList, data).then((res) => {
        this.GetQuestionByIdCopy(res.result);
        this.listconhttpnumCopy = res.result.length;
      });
    },
    // 章节试题列表
    GetQuestionByIdCopy(e) {
      var that = this;
      var data = {
        question_ids: JSON.stringify(e),
      };
      this.$post(URL.GetQuestionById, data).then((res) => {
        //章节
        if (res.result) {
          that.paperlistCopy = res.result;
          that.paperlistCopy.forEach(function (data, index) {
            var html = data.question_text;
            // store_type 1新 2旧题 判断
            if (data.store_type == 2) {
              var urltext = html.match(/(\S*)SYS/)[1]
              that.$get(data.answer).then((res1) => {
                var reg = new RegExp('src="', "g");
                that.realurl2 = res1.replace(reg, 'src="' + urltext);
                that.paperlistCopy[index].answer = that.realurl2;
                that.nums++;
              });
              that.$get(data.question_text).then((res2) => {
                var reg = new RegExp('src="', "g");
                that.realurl2 = res2.replace(reg, 'src="' + urltext);
                that.paperlistCopy[index].question_text = that.realurl2;
                that.nums++;
              });
            }
            // that.gettypelistCopy.forEach(function (data1) {
            //   if (data.question_type == data1.type_id) {
            //     that.paperlistCopy[index].question_type = data1.type_name;
            //   }
            // });
            // that.formatypearr.forEach(function (data2) {
            //   if (data.question_level == data2.fmttype_id) {
            //     that.paperlistCopy[index].question_level = data2.fmttype_name;
            //   }
            // });
          });
        }
      });
    },
  },
};
</script>

<style lang='less' scoped>
.bigbox {
  background-color: #fff;
  border-radius: 8px;
  border-top: 1px solid #409eff;
  .box {
    font-size: 14px;
    padding: 15px;
    img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
  }
  .subject {
    width: 810px;
    padding: 18px 10px;

    padding-left: 20px;
    border-left: 1px solid #f3f3f3;
    .four {
      img {
        vertical-align: middle;
        margin-right: 6px;
      }
      span {
        margin-right: 40px;
      }
    }
    .changeSubject {
      cursor: pointer;
    }
  }
}
.news {
  cursor: pointer;
}
.el-dialog__wrapper/deep/.el-dialog {
  width: 27% !important;
  min-height: 500px !important;
}
</style>
